const LANG_TO_LOCALE: Record<string, string> = {
  es: 'es-AR',
  en: 'en-US',
  pt: 'pt-BR',
  fr: 'fr-FR',
  de: 'de-DE',
};

export function formatAmount(value: number, lang: string): string {
  const locale = LANG_TO_LOCALE[lang] || lang;
  return value.toLocaleString(locale);
}
